import { useStateStore } from "@/context/stateStore";
import { IPlant } from "@/models/types/plant";
import { apiRequest, hasBaseUrl, hasEmail } from "../helpers/apiClient";

export async function CreatePlant({ plant, user, urlToUse }: { plant: IPlant, user: string, urlToUse: string }) {

    if (!plant) {
        return { status: false, message: "Plant name, image URL, and description are required" };
    }

    if (!hasEmail(user)) {
        return { status: false, message: "User email is required" };
    }

    if (!hasBaseUrl(urlToUse)) {
        return { status: false, message: "Base URL is not set" };
    }

    const result = await apiRequest<{ newPlant: IPlant }>({
        url: `${urlToUse}/api/plants/create`,
        method: 'POST',
        body: { plant },
        failureMessage: 'Error creating plant',
    });

    if (!result.success || !result.data) {
        return { status: false, message: result.message };
    }

    const data = result.data;
        const newPlant = data.newPlant as IPlant;
        if (!newPlant || !newPlant._id) {
            return { status: false, message: "Invalid plant data returned" };
        }
        const iPlants = useStateStore.getState().plants;
        useStateStore.setState({
            plants: [...iPlants, data.newPlant],
        });
        return { status: true, message: "Plant created successfully" };


}
